import * as React from 'react';
import './pdf.css';
import { PVAPage } from '../layout/PVAPage';

export interface PdfTitlePageProps {
    title: string;
    subtitle?: string;
    date?: string;
    name?: string;
    organization?: string;
    currentPage?: number;
    totalPages?: number;
    preventInteraction?: boolean;
}

export interface PdfFooterProps {
    currentPage?: number;
    totalPages?: number;
}

export interface PdfProps {
    fontSize?: string;
    className?: string;
}

export class Pdf extends React.Component<PdfProps> {
    static Page = (props: any) => (
        <div className={props.className ? `page ${props.className}` : 'page'}>
        {props.children}
        </div>
    );

    static Footer = (props: PdfFooterProps) => {
        const currentYear = new Date().getFullYear();
        const formattedDate = new Date().toLocaleDateString('en-US');
        return (
            <div className="pdf-footer">
                <div className="left">Pondera Technologies, LLC ® {currentYear}</div>
                <div className="center">
                    {props.currentPage !== undefined && props.totalPages !== undefined && (
                        <>Page {props.currentPage} of {props.totalPages}</>
                    )}
                </div>
                <div className="right">Generated {formattedDate}</div>
            </div>
        );
    };

    static TitlePage = (props: PdfTitlePageProps) => (
        <div className="page title-page">
            <div className="title-content">
                {props.subtitle && <div className="subtitle">{props.subtitle}</div>}
                <div className="title">{props.title}</div>
                <div className="details">
                    {props.date && <div className="date">Prepared {props.date}</div>}
                    {props.name && <div className="name">{props.name}</div>}
                    {props.organization && <div className="organization">{props.organization}</div>}
                </div>
            </div>
            <div className="title-footers">
                <PVAPage.Footer preventInteraction={props.preventInteraction}/>
                <Pdf.Footer currentPage={props.currentPage} totalPages={props.totalPages} />
            </div>
        </div>
    );

    render() {
        const style = this.props.fontSize ? { fontSize: this.props.fontSize } : {};
        const className = this.props.className ? `pdf ${this.props.className}` : 'pdf';
        return (
            <div className={className} style={style}>
                {this.props.children}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pdf/Pdf.tsx